import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { APP_SETTINGS, AppSettings } from 'src/app/settings';
import { ForumApiService } from 'src/app/service/forum.api.service';
import { EncryptionService } from 'src/app/service/encryption.service';
import { StorageService } from 'src/app/service/storage.service';
import { Router } from '@angular/router';
import { DataService } from 'src/app/service/data.service';
import { ConstantService } from 'src/app/service/constant.service';
import { DataLoginService } from 'src/app/service/dataLogin.service';
import { CleverTapService } from 'src/app/service/clevertap.service';
import clevertap from 'clevertap-web-sdk';

declare global {
  interface Window {
    openTicketsTab: () => void;
  }
}
@Component({
  selector: 'app-header-search-bar',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './header-search-bar.component.html',
  styleUrls: ['./header-search-bar.component.less']
})

export class HeaderSearchBarComponent {

  searchListArray = [];
  showLoader = false;
  showResults = false;
  emailId: string;
  jwtToken: string;
  isLoggedIn: string;
  accessToken: string;
  mainCategory: string;
  subCategory : string; 

  constructor(
    @Inject(APP_SETTINGS) private settings: AppSettings,
    private http: HttpClient,
    private forumApiService: ForumApiService,
    private fb: FormBuilder,
    private encryptionService: EncryptionService,
    private storageService: StorageService,
    private router: Router,
    private dataService: DataService,
    private constantService: ConstantService,
    private dataLoginService: DataLoginService,
    private cleverTapService: CleverTapService,
  ) { }

  ngOnInit(): void {
    this.dataLoginService.data.subscribe((checkLogin) => {
      if(checkLogin === this.constantService.yes){
        this.isLoggedIn = checkLogin;
      } else {
        this.isLoggedIn = this.constantService.no;
      }      
    });

    this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
  }

  searchForm = this.fb.group({
    searchText: [null]
  });

  get f() {
    return this.searchForm.controls;
  }

  omit_special_char(event){
    try {
      var k;  
      k = event.charCode;
      return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 63 || (k >= 48 && k <= 57)); 
    } catch (e) {
      console.log('Error in omit special char method - ', e);
      return false;
    }
  }

  async searchByString(): Promise<void> {
    try {
      const portalId = this.encryptionService.decryptUsingAES_256(
        this.storageService.getItem(this.constantService.portalId)
      );
      const searchStr = this.searchForm.controls.searchText.value;
      const from = this.constantService.searchByStringRequestConstant.from;
      const limit = this.constantService.searchByStringRequestConstant.limit;
      const locale = this.constantService.searchByStringRequestConstant.englishLanguage;

      if(this.searchForm.value.searchText == ''){
      this.showResults = false;
      }

      if(this.searchForm.controls.searchText.value != '') {
        await this.forumApiService
        .searchByString(portalId, searchStr, from, limit, locale)
        .then(async (searchByStringResponse) => {
          if(searchByStringResponse.data.length != 0){
            for (let i = 0; i < searchByStringResponse.data.length; i++) {
              this.showResults = true;
              this.searchListArray[i] = searchByStringResponse.data[i];
            }
          } else if(searchByStringResponse.data.length == 0) {
            this.searchListArray = [];
            this.searchListArray[0] = this.constantService.noResultFoundText;
          }
        });
      } else {
        this.searchListArray = [];
      }
      
    } catch (e) {
      console.group('Error Occured in searchByString : ', e);
      this.searchListArray = [];
      this.searchListArray[0] = this.constantService.noResultFoundText;
    }
  }

  goTosubCategoryAnswers(questionId: string, catId: string, questionTitle:string): void {
    this.showResults = false;

    if(this.storageService.getItem(this.constantService.isLoggedIn) == this.constantService.yes) {
      
      clevertap.init('R74-5R4-6W5Z');

      setTimeout(() => {
        const clientId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode));
        clevertap.onUserLogin.push({
          "Site": {
              "Identity":clientId
          }
        });        
        let clevertapData = {
          action : 'search',
          page_section : 'search',
          keyword : this.searchForm.controls.searchText.value,
          client_code : clientId
        };    
        this.cleverTapService.clevertapCommonFunction('faq_page_click',clevertapData);          
      }, 3000);  
    }

    this.dataService.data.subscribe((mainCategoryArray) => {
      mainCategoryArray.forEach(mainCat => {
        mainCat.child.forEach(subCat => {
          if(subCat.id == catId){
            this.mainCategory = mainCat.permalink;
            this.subCategory = subCat.permalink;
          }
        });
      });
    });
    this.router.navigate([this.mainCategory + '/' + this.subCategory + '/' + questionTitle], {queryParams: { questionId }});
  }

  goToViewTicket(): void {
    this.router.navigateByUrl(this.constantService.navigationComponentPage.viewTicket);
  }

  openTicketAndCleverTapEvent() {
    try {
      window.openTicketsTab();
      this.addCleverTapEvent();
    } catch(e) {
      console.log('Error Occured in openTicketAndCleverTapEvent : ', e);
    }
  }

  addCleverTapEvent() {
    try {
      this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
    if(this.isLoggedIn == this.constantService.yes) {
      clevertap.init('R74-5R4-6W5Z');
      setTimeout(() => {
        const clientId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode));
        clevertap.onUserLogin.push({
          "Site": {
              "Identity": clientId
          }
        });
        let clevertapData = {
          action : 'track_ticket',
          page_section : 'support',
          client_code : clientId
        };
        this.cleverTapService.clevertapCommonFunction('faq_page_click',clevertapData);
      }, 3000);
      
    }
    } catch (e) {
      console.log('Error in addCleverTapEvent - ', e);
    }
  }

}